import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Redo({ color = 'icon.primary', strokeWidth = '1.5', ...props }) {
  return (
    <IconBase viewBox='0 0 18 16' {...props}>
      <Path
        d='M7.952 15H6.07V15C3.255 15 0.952 12.75 0.952 10V10C0.952 7.25 3.255 5 6.07 5H17'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M13 9L17 5L13 1'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
    </IconBase>
  )
}

Redo.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Redo
